// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"InfoCard_wrapper__3F4GM","subtitle":"InfoCard_subtitle__2PlBr"};